import { EnvService } from '@aipb/gulliver/env/util';

import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'fr-coop-messages-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './coop-messages-button.component.html',
  styleUrls: ['./coop-messages-button.component.scss']
})
export class CoopMessagesButtonComponent {
  @Input() isLoggedIn: boolean;
  @Input() hasPersonalContent: boolean;
  @Input() isPersonalContentEnabled: boolean;

  @Output() action = new EventEmitter();

  private env = inject(EnvService);

  get enabled() {
    return this.env.coopEnabled;
  }
}
